// Глобальный обработчик событий для автоматического обновления sitemap
import { toast } from 'sonner';
import SitemapGenerator from '@/utils/sitemapGenerator';

class SitemapEventHandler {
    constructor() {
        this.updateSitemap = null;
        this.isUpdating = false;
    }

    // Инициализация с функцией обновления
    init(updateFunction) {
        this.updateSitemap = updateFunction;
    }

    // Автоматическое обновление sitemap
    async autoUpdate(articleInfo, action = 'updated') {
        if (!this.updateSitemap || this.isUpdating) {
            console.log('⏭️ Skipping sitemap update - already updating or not initialized');
            return;
        }

        this.isUpdating = true;
        
        try {
            console.log(`🔄 Auto-updating sitemap after article ${action}:`, articleInfo);
            
            const success = await this.updateSitemap(articleInfo);
            
            if (success) {
                const actionText = {
                    'created': 'создана',
                    'updated': 'обновлена', 
                    'deleted': 'удалена',
                    'published': 'опубликована'
                }[action] || 'изменена';

                toast.success(`Статья "${articleInfo.title}" ${actionText} и добавлена в sitemap`);
            }
        } catch (error) {
            console.error('❌ Error in auto sitemap update:', error);
            toast.error('Ошибка автоматического обновления sitemap');
        } finally {
            this.isUpdating = false;
        }
    }

    // Обработчики для различных действий
    async onArticleCreated(articleInfo) {
        await this.autoUpdate(articleInfo, 'created');
    }

    async onArticleUpdated(articleInfo) {
        await this.autoUpdate(articleInfo, 'updated');
    }

    async onArticleDeleted(articleInfo) {
        await this.autoUpdate(articleInfo, 'deleted');
    }

    async onArticlePublished(articleInfo) {
        await this.autoUpdate(articleInfo, 'published');
    }
}

// Экспорт singleton экземпляра
export const sitemapEventHandler = new SitemapEventHandler();

// React hook для использования в компонентах
export const useSitemapEventHandler = (updateFunction) => {
    // Инициализация при первом использовании
    if (!sitemapEventHandler.updateSitemap && updateFunction) {
        sitemapEventHandler.init(updateFunction);
    }
    
    return sitemapEventHandler;
};
